var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.333 17.5l-5.25-5.25a5.08 5.08 0 01-3.167 1.083c-1.513 0-2.794-.524-3.843-1.573C3.024 10.712 2.5 9.43 2.5 7.917c0-1.514.524-2.795 1.573-3.844S6.403 2.5 7.917 2.5c1.514 0 2.795.524 3.843 1.573 1.049 1.049 1.573 2.33 1.573 3.844a5.08 5.08 0 01-1.083 3.166l5.25 5.25-1.167 1.167zm-8.416-5.833c1.041 0 1.927-.365 2.656-1.094.73-.73 1.094-1.615 1.094-2.656 0-1.042-.365-1.927-1.094-2.657-.73-.729-1.615-1.093-2.656-1.093-1.042 0-1.927.364-2.657 1.093-.729.73-1.093 1.615-1.093 2.657 0 1.041.364 1.927 1.093 2.656.73.73 1.615 1.094 2.657 1.094z",
    fill: "currentColor"
  }))));
}
export default SvgSearch;